import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import FilterPremiosPendientesPagar from 'views/reports/premiosPendientesPagar/filterPremiosPendientesPagar'; // Importing filter component
import TablePremiosPendientesPagar from 'views/reports/premiosPendientesPagar/tablePremiosPendientesPagar'; // Importing table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the view for pending payments of prizes.
 * @extends JetView
 */
export default class PremiosPendientesPagarView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration
        const toolbar = {
            view: 'toolbar', // Toolbar component
            id: 'toolbar', // Unique identifier for the toolbar
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                // Columns in the toolbar
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                    size: 10000000, // Maximum number of items to display
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export', // Name of the select
                    id: 'Export', // Unique identifier for the select
                    width: 120, // Width of the select
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        // Options for export
                        { id: '1', value: 'Excel' }, // Export to Excel
                        { id: '2', value: 'PDF' }, // Export to PDF
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for change event
                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('treetable'); // Get the tree table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        // Check for export type
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    // Trigger export event
                                    {
                                        NameReport:
                                            ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Premios pendientes por pagar', // Report name
                                        TypeReport: 'Excel', // Report type
                                    },
                                ]);
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Premios pendientes por pagar', // Filename for the export
                                    ignore: { detailTittle: true }, // Ignore detail title
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF is selected
                                    this.app.callEvent('export:data', [
                                        // Trigger export event
                                        {
                                            NameReport:
                                                ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) +
                                                'Premios pendientes por pagar', // Report name
                                            TypeReport: 'PDF', // Report type
                                        },
                                    ]);
                                    webix.toPDF($$('treetable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Premios pendientes por pagar', // Filename for the export
                                        autowidth: true, // Auto width for PDF
                                        ignore: { detailTittle: true }, // Ignore detail title
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        }.bind(this), // Bind the context
                    },
                },
            ],
        };
        const toolbar2 = {
            view: 'toolbar', // Second toolbar component
            id: 'toolbar2', // Unique identifier for the second toolbar
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                // Columns in the second toolbar
                {
                    view: 'select', // Dropdown for page size selection
                    options: ['10', '20', '50', '100'], // Options for page size
                    width: 70, // Width of the select
                    on: {
                        onChange: function () {
                            // Event handler for change event
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the data table
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA2', // Unique identifier for the second pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export', // Name of the select
                    id: 'Export2', // Unique identifier for the select
                    width: 120, // Width of the select
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        // Options for export
                        { id: '1', value: 'Excel' }, // Export to Excel
                        { id: '2', value: 'PDF' }, // Export to PDF
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for change event
                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('datatable'); // Get the data table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        // Check for export type
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    // Trigger export event
                                    {
                                        NameReport:
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Premios pendientes por pagar', // Report name
                                        TypeReport: 'Excel', // Report type
                                    },
                                ]);
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Premios pendientes por pagar', // Filename for the export
                                    ignore: { detailTittle: true }, // Ignore detail title
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF is selected
                                    this.app.callEvent('export:data', [
                                        // Trigger export event
                                        {
                                            NameReport:
                                                ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                                'Premios pendientes por pagar', // Report name
                                            TypeReport: 'PDF', // Report type
                                        },
                                    ]);
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Premios pendientes por pagar', // Filename for the export
                                        autowidth: true, // Auto width for PDF
                                        ignore: { detailTittle: true }, // Ignore detail title
                                    });
                                }
                            }
                            $$('Export2').setValue(''); // Reset export selection
                        }.bind(this), // Bind the context
                    },
                },
            ],
        };
        const left = {
            css: 'int-left', // CSS class for styling
            Width: 250, // Width of the left panel
            responsiveCell: false, // Disable responsive cell
            rows: [
                // Rows in the left panel
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Theme for the toolbar
                    elements: [
                        {
                            view: 'label', // Label for the title
                            label: _('Premios pendientes por pagar'), // Title text
                            width: 250, // Width of the label
                        },
                        {
                            type: 'wide', // Wide button type
                            css: 'close-bottom', // CSS class for styling
                            id: 'button-search', // Unique identifier for the search button
                            cols: [
                                {
                                    view: 'icon', // Icon button for search
                                    icon: 'wxi-search', // Search icon
                                    bottom: 20, // Bottom margin
                                    right: 35, // Right margin
                                    width: 30, // Width of the icon
                                    height: 30, // Height of the icon
                                    click: () => {
                                        // Click event handler
                                        $$('filterPopup').show(); // Show filter popup
                                    },
                                },
                            ],
                        },
                    ],
                },
                FilterPremiosPendientesPagar, // Filter component
                TablePremiosPendientesPagar, // Table component
                toolbar, // First toolbar
                toolbar2, // Second toolbar
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen
        return {
            id: 'a5', // Unique identifier for the form
            type: 'clean', // Clean type for the form
            view: 'form', // Form view
            scroll: 'y', // Enable vertical scrolling
            css: 'scrolling', // CSS class for scrolling
            rows: [
                // Rows in the form
                {
                    responsive: 'a5', // Responsive layout
                    type: 'wide', // Wide type
                    cols: [left], // Columns in the form
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            if (screen.width < 500 || screen.height < 500) {
                // Check for small screen size
                var childs = $$('toolbar').getChildViews(); // Get child views of the first toolbar
                $$('toolbar').removeView(childs[1]); // Remove the second child view
                $$('pagerA').define('group', 1); // Define group for the pager
                var childs2 = $$('toolbar2').getChildViews(); // Get child views of the second toolbar
                $$('toolbar2').removeView(childs2[2]); // Remove the third child view
                $$('pagerA2').define('group', 1); // Define group for the second pager
            }
            if (screen.width > 500 && screen.height > 500) {
                // Check for larger screen size
                $$('button-search').hide(); // Hide the search button
            }
        });
    }
}

// FILE DOCUMENTED
